import { useCmsStore } from "@/components/AppHooks";
import { HomeMaster } from "./master";
import { HomeSmirnoff } from "./smirnoff";
import { HomeTanqueray } from "./tanqueray";
import { THomeProps, THomeTanquerayProps } from "./type";
import { styleName } from "@/config/const";

export function Home(props: {
    component: Array<THomeProps | THomeTanquerayProps>
}) {
    const { storeConfig: { storeStyleName = styleName.Master } } = useCmsStore()!
    const pageProps = props.component.find((item) => item.storeStyleName === storeStyleName)
    return (
        <>
            {storeStyleName === styleName.Master && <HomeMaster {...pageProps as THomeProps} />}
            {storeStyleName === styleName.SmirnoffKenya && <HomeSmirnoff {...pageProps as THomeProps} />}
            {storeStyleName === styleName.Tanqueray && <HomeTanqueray {...pageProps as THomeTanquerayProps} />}
        </>
    );
}